module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_3_5_2.734a2190.jpeg";